module.exports = __webpack_public_path__ + "static/media/DavidBoyd.970b15cd.jpg";